export enum IncidentLocationAddressType {
  HIGHWAY = "Highway",
  ADDRESS = "Address",
  STREET = "Street",
}
